import React from "react";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { Retailer } from "../../types/tenant";
import {
  Control,
  Controller,
  FormState,
  UseFormRegister,
} from "react-hook-form";
import { FormSection } from "../../components/FormSection";
import InputField from "../../components/InputField";
import { stateSelectOptions } from "../../types/states";
import SelectField from "../../components/SelectField";
import { FormData } from "./FormData";

interface CompanyInfoTabShippingAddressProps {
  retailer: Retailer | null;
  // form props
  control: Control<FormData>;
  formState: FormState<FormData>;
  register: UseFormRegister<FormData>;
}

export const CompanyInfoTabShippingAddress: React.FC<
  CompanyInfoTabShippingAddressProps
> = ({ retailer, control, formState, register }) => {
  return (
    <FormSection heading="Shipping Address" sx={{ marginBottom: 0 }}>
      <Grid xs={12} md={6}>
        <InputField
          {...register("retailerShippingAddress1")}
          disabled={!retailer?.canEdit}
          fullWidth
          label="Address"
          placeholder="Enter Address"
          error={!!formState.errors.retailerShippingAddress1}
          helperText={formState.errors.retailerShippingAddress1?.message}
        />
      </Grid>
      <Grid xs={12} md={6}>
        <InputField
          {...register("retailerShippingAddress2")}
          disabled={!retailer?.canEdit}
          fullWidth
          label="Address 2"
          placeholder="Enter Address 2"
          error={!!formState.errors.retailerShippingAddress2}
          helperText={formState.errors.retailerShippingAddress2?.message}
        />
      </Grid>
      <Grid xs={12} md={6}>
        <InputField
          {...register("retailerShippingCity")}
          disabled={!retailer?.canEdit}
          fullWidth
          label="City"
          placeholder="Enter City"
          error={!!formState.errors.retailerShippingCity}
          helperText={formState.errors.retailerShippingCity?.message}
        />
      </Grid>
      <Grid xs={12} md={6}>
        <Controller
          control={control}
          name="retailerShippingState"
          render={({ field, fieldState }) => (
            <SelectField
              {...field}
              label="State"
              placeholder="Select State"
              disabled={!retailer?.canEdit}
              fullWidth
              options={stateSelectOptions}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      </Grid>
      <Grid xs={12} md={6}>
        <InputField
          {...register("retailerShippingZip")}
          disabled={!retailer?.canEdit}
          fullWidth
          label="ZIP"
          placeholder="Enter ZIP"
          error={!!formState.errors.retailerShippingZip}
          helperText={formState.errors.retailerShippingZip?.message}
        />
      </Grid>
    </FormSection>
  );
};
